<div class="login-container display-flex flex-column justify-content-center align-items-center grid-gap-32 h-100">
  <app-animation></app-animation>
</div>
